import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserDataPasswordFormValidator from './views/UserDataPasswordFormValidator';

export default class UserDataPasswordNode extends NodeModule {
  start(options) {
    console.log('Starting User Data Password');
    const userDataPassword = new Form({el: options.el, formEl: '#userForm', type: (opts) => new UserDataPasswordFormValidator(opts)});
  }
}